<!-- 计数器组件 -->
<template>
    <div class="input-number">
        <div class="minus" @click="minus">
            <i class="el-icon-minus"></i>
        </div>
        <div class="input-ctn">
            <input type="text"
                   v-model="number"
                   @focus="isFours = true"
                   @blur="inputBlur"
            >
        </div>
        <div class="plus" @click="plus">
            <i class="el-icon-plus"></i>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        components: {

        },
        props:{
            data:{},
            max:{
                default:'99999999'
            },
            index:{}
        },
        data(){
            return {
                isFours:false,
                number:1
            }
        },
        mounted(){
            this.number = this.data.BuyCount
        },
        watch:{
            number(value,beforeValue){
                // if(beforeValue > this.max){
                //     return
                // }
                if (!this.isFours){
                    if (value <= this.max){
                        this.number = parseInt(value)
                        this.$emit('change',this.data,this.number,this.index)
                    }
                    else {
                        this.number = this.max
                    }
                }
            }
        },
        methods:{
            inputBlur(){
                this.isFours = false
                if (Number(this.number) <= 0 || !Number(this.number) ){
                    this.number = 1
                }
                if (this.number > this.max){
                    this.number = this.max
                    // return
                }
                this.number = parseInt(this.number)
                this.$emit('change',this.data,this.number,this.index)
            },
            // -
            minus(){
                if (this.number > 1){
                    this.number = Number(this.number) - 1
                }
            },
            // +
            plus(){
                this.number = Number(this.number) + 1
            }
        }
    }
</script>
<style lang="less" scoped>
    .input-number {
        width: 118px;
        display: flex;
        border: 1px solid @border3Color;
        border-radius: 5px;
        height: 36px;
    }
    .input-ctn {
        line-height: 1;
        input{
            border:none;
            text-align: center;
            width: 50px;
            height: 34px;
            padding: 0;
            margin: 0;
            border-left: 1px solid @border3Color;
            border-right: 1px solid @border3Color;
        }
    }
    .minus,.plus {
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
</style>
